<template>
  <div>
    <div
      class="mb-3 check-correct-option-info"
      v-if="selectedSlideIds.length > 1"
    >
      <i class="fas fa-info-circle" />
      <span class="pl-1">
        You are applying changes to {{ selectedSlideIds.length }} slides.
      </span>
    </div>

    <div
      class="audio-track"
      v-click-outside="stopAllbmg"
    >
      <label class="label-option mt-2">Background music</label>
      <div class="mt-0 mb-2 slide-image-config" v-if="$store.getters.selectedSlide.audioLink">
        <div class="text-center image-box">
          {{ $store.getters.selectedSlide.audioName }}
        </div>
        <div class="audio-tag horizontal layout center-justified">
          <audio :src="$store.getters.selectedSlide.audioLink.url" controls ref="audio-config" />
        </div>
        <div class="horizontal layout center center-justified">
          <div
            class="horizontal layout center item-video-change change-audio-track"
            v-if="$store.state.plan.group != 'free'"
          >
            <a>
              <i class="pr-2 far fa-file-audio" />
              <span @click="toggleSelectBgmMenuSection">Change audio track</span>
            </a>
          </div>
          <div class="horizontal layout center item-video-change">
            <a>
              <i class="pr-2 fas fa-trash-alt" />
              <span @click="deleteAudio()">Remove</span>
            </a>
          </div>
        </div>
      </div>
      <div
        class="mt-0 button-add-audio"
        v-if="!$store.getters.selectedSlide.audioLink || showSelectBgmMenuSection"
      >
        <div v-if="$store.state.plan.group != 'free'" class="horizontal layout center">
          <div class="flex relative">
            <div
              class="input-select-track cursor-pointer
              horizontal layout center"
              @click="openBackgroundListMenu"
            >
              <i class="fas fa-music"></i>
              <div class="flex">
                <span>Select</span>
              </div>
              <i class="fas fa-caret-down"></i>
            </div>
            <div
              class="audience-list-track"
              v-if="showBmgList"
              v-click-outside="closeBgmTrack"
            >
              <ul>
                <li
                  class="horizontal layout center"
                  v-for="item in bmgList"
                  :key="item.title"
                  @click="selecAudio(item, $event)"
                >
                  <div class="button-play-track" @click.stop="playDemo(item)">
                    <i
                      class="fas fa-play"
                      style="margin-left: 5%;"
                      v-if="!item.isPlay"
                    ></i>
                    <i class="fas fa-pause" v-if="item.isPlay"></i>
                  </div>
                  <div>
                    <span
                      :class="{'font-bold' : (slideAudioName === item.title)}"
                    >
                      {{ item.title }}
                    </span>
                  </div>
                  <div
                    v-if="slideAudioName === item.title"
                    class="icon-selected-track"
                  >
                    <img src="@/assets/images/elements/check-simple.svg">
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="select-track-or">
            or
          </div>
          <aha-button
            class="font-normal"
            @click="openModalUploadAudio"
          >
            Upload
          </aha-button>
        </div>

        <div class="block-body" v-if="$store.state.plan.group == 'free'">
          <p class="mb-3">
            Please upgrade your account to enable this feature.
          </p>
          <ButtonUpgrade />
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="label-option mt-4">For the presenter</label>
      <div class="form-check form-check-inline">
        <div
          class="custom-control custom-checkbox"
          :class="{ 'is-null': $store.getters.selectedSlide.audioShowControl == null }"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            :disabled="$store.state.plan.group == 'free'
              || !$store.getters.selectedSlide.audioLink"
            id="presenter-show-media-control"
            v-model="$store.getters.selectedSlide.audioShowControl"
            @change="updateSlideByType(2)"
          >
          <label
            class="custom-control-label"
            for="presenter-show-media-control"
          >Show media controls</label>
          <span class="pl-1 title-table-presentation-tooltip">
            <b-button
              v-tooltip="'Let you pause, resume, seek…'"
              class="tooltip-btn"
            />
            <i class="fas fa-question-circle" />
          </span>
        </div>
      </div>
      <div class="form-check form-check-inline">
        <div
          class="custom-control custom-checkbox"
          :class="{ 'is-null': $store.getters.selectedSlide.audioAutoPlay == null }"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            :disabled="$store.state.plan.group === 'free'
              || !$store.getters.selectedSlide.audioShowControl
              || !$store.getters.selectedSlide.audioLink"
            id="presenter-autoplay"
            v-model="$store.getters.selectedSlide.audioAutoPlay"
            @change="updateSlideByType(3)"
          >
          <label class="custom-control-label" for="presenter-autoplay">Autoplay</label>
          <span class="pl-1 title-table-presentation-tooltip">
            <b-button
              v-tooltip="'Automatically play the track (on your presenting screen)'"
              class="tooltip-btn"
            />
            <i class="fas fa-question-circle" />
          </span>
        </div>
      </div>
      <div class="form-check form-check-inline">
        <div
          class="custom-control custom-checkbox"
          :class="{ 'is-null': $store.getters.selectedSlide.audioRepeat == null }"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            :disabled="$store.state.plan.group == 'free'
              || !$store.getters.selectedSlide.audioLink"
            id="presenter-auto-repeat"
            v-model="$store.getters.selectedSlide.audioRepeat"
            @change="updateSlideByType(4)"
          >
          <label class="custom-control-label" for="presenter-auto-repeat">On repeat</label>
          <span class="pl-1 title-table-presentation-tooltip">
            <b-button
              v-tooltip="'Suitable for background tracks'"
              class="tooltip-btn"
            />
            <i class="fas fa-question-circle" />
          </span>
        </div>
      </div>

      <label class="label-option mt-4">For the audience</label>
      <div class="form-check form-check-inline">
        <div
          class="custom-control custom-checkbox"
          :class="{ 'is-null': $store.getters.selectedSlide.audioPlayOnAudience == null }"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            :disabled="$store.state.plan.group == 'free'
              || !$store.getters.selectedSlide.audioLink"
            id="audience-playon"
            v-model="$store.getters.selectedSlide.audioPlayOnAudience"
            @change="updateSlideByType(5)"
          >
          <label
            class="custom-control-label"
            for="audience-playon"
          >Playable on audience's devices</label>
          <span class="pl-1 title-table-presentation-tooltip">
            <b-button
              v-tooltip="'Let your audience play the track on their devices'"
              class="tooltip-btn"
            />
            <i class="fas fa-question-circle" />
          </span>
        </div>
      </div>
      <div class="sub-group" v-if="$store.getters.selectedSlide.audioPlayOnAudience">
        <div class="form-check form-check-inline">
          <div
            class="custom-control custom-checkbox"
            :class="{ 'is-null': $store.getters.selectedSlide.audioAudienceShowControl == null }"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :disabled="$store.state.plan.group == 'free'
                || !$store.getters.selectedSlide.audioLink"
              id="audience-show-control"
              v-model="$store.getters.selectedSlide.audioAudienceShowControl"
              @change="updateSlideByType(6)"
            >
            <label
              class="custom-control-label"
              for="audience-show-control"
            >Show media controls</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Let the audience pause, resume, seek…'"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
        <div class="form-check form-check-inline">
          <div
            class="custom-control custom-checkbox"
            :class="{ 'is-null': $store.getters.selectedSlide.audioAudienceAutoPlay == null }"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :disabled="$store.state.plan.group == 'free'
                || !$store.getters.selectedSlide.audioAudienceShowControl
                || !$store.getters.selectedSlide.audioLink"
              id="audience-autoplay"
              v-model="$store.getters.selectedSlide.audioAudienceAutoPlay"
              @change="updateSlideByType(7)"
            >
            <label class="custom-control-label" for="audience-autoplay">Autoplay</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Automatically play the track when the presenter goes to this slide'"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
        <div class="form-check form-check-inline">
          <div
            class="custom-control custom-checkbox"
            :class="{ 'is-null': $store.getters.selectedSlide.audioAudienceRepeat == null }"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              :disabled="$store.state.plan.group == 'free'
                || !$store.getters.selectedSlide.audioLink"
              id="audience-on-repeat"
              v-model="$store.getters.selectedSlide.audioAudienceRepeat"
              @change="updateSlideByType(8)"
            >
            <label class="custom-control-label" for="audience-on-repeat">On repeat</label>
            <span class="pl-1 title-table-presentation-tooltip">
              <b-button
                v-tooltip="'Suitable for background tracks'"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>
      <AudioAutoPlayInfo v-if="$store.getters.selectedSlide.audioPlayOnAudience" />
    </div>

    <UploadAudio
      v-if="showModalUploadAudio"
      @hideModal="hideModalUploadAudio"
      :type="''"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions } from 'vuex'
import UploadAudio from '@/components/presentations/UploadAudio'
import Socket from '@/socket'
import ButtonUpgrade from '@/components/presentations/ButtonUpgrade'
import AudioAutoPlayInfo from '@/components/presentations/AudioAutoPlayInfo.vue'
import SlideApi from '@/api/slide'
import Constant from '@/constant'
import Util from '@/util'
import gaCategories from '@/constant/gaCategories'
import EventBus from '@/eventBus'
import bmgList from '@/constant/bgm'

const { PRESENTATION_EDITOR } = gaCategories

export default {
  name: 'AudioConfig',
  components: {
    UploadAudio,
    ButtonUpgrade,
    AudioAutoPlayInfo,
  },
  data() {
    return {
      showModalUploadAudio: false,
      bmgList,
      showBmgList: false,
      showSelectBgmMenuSection: false,
    }
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      slideAudioName: (state) => state.slideActive.audioName,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      selectedSlideIds: (state) => state.selections.selectedSlideIds,
    }),
  },
  watch: {
    'slideActive.audioVolume': function (audioVolume) {
      if (this.$refs['audio-config'].audioVolume !== audioVolume) {
        this.$refs['audio-config'].volume = audioVolume
      }
    },
    'slideActive.audioMuted': function (audioMuted) {
      if (this.$refs['audio-config'].muted !== audioMuted) {
        this.$refs['audio-config'].muted = audioMuted
      }
    },
    '$store.getters.selectedSlide.audioLink': function (audioLink) {
      if (audioLink) {
        this.showSelectBgmMenuSection = false
        this.onAudioVolume()
      }
    },
  },

  mounted() {
    this.onAudioVolume()
    EventBus.$on('audio: open-audio-modal', () => {
      this.openModalUploadAudio()
    })
    this.triggerTrackingClickAudiobtn()
  },

  destroyed() {
    EventBus.$off('audio: open-audio-modal')
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    onAudioVolume() {
      setTimeout(() => {
        const elAudio = this.$refs['audio-config']
        if (elAudio) {
          if (this.slideActive.audioVolume) {
            elAudio.volume = this.slideActive.audioVolume
          }
          if (this.slideActive.audioMuted) {
            elAudio.muted = this.slideActive.audioMuted
          }
          elAudio.onvolumechange = () => {
            if (elAudio.muted !== this.slideActive.audioMuted) {
              this.updateVolume(elAudio.volume, elAudio.muted)
              return
            }
            if (elAudio.volume === this.slideActive.audioVolume) return
            this.updateVolume(elAudio.volume)
          }
        }
      }, 250)
    },
    updateVolume: _.debounce(function debounceAudioVolume(audioVolume, muted) {
      const payload = {
        audioVolume,
      }
      if (muted !== null) {
        payload.audioMuted = muted
      }
      SlideApi.updateSlideById(this.slideActive.id, payload)
      this.updateSlideActiveAction(payload)
      Util.gaTrackEvent('Presentation Editor', 'Slide > Audio > Update Volumne', '')
    }, 300),

    toggleSelectBgmMenuSection() {
      this.showSelectBgmMenuSection = !this.showSelectBgmMenuSection
      const preDeleteAudioname = this.slideActive.audioName
      Util.ga4Track('Pick a sound track from the list', {
        eventAction: 'Audio Tab > Background music > Change audio track',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: preDeleteAudioname,
      })
    },
    openModalUploadAudio() {
      this.showModalUploadAudio = true
    },
    hideModalUploadAudio() {
      this.showModalUploadAudio = false
    },
    async deleteAudio() {
      const preDeleteAudioname = this.slideActive.audioName
      await this.updateSlide({
        audioLink: null,
        audioName: null,
      })
      Util.ga4Track('Remove audio track', {
        eventAction: 'Audio Tab > Background music > Remove an audio track',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: preDeleteAudioname,
      })
    },

    async updateSlideByType(typeUpdate) {
      let payload = {}
      if (typeUpdate === 2) {
        payload = {
          audioShowControl: this.$store.getters.selectedSlide.audioShowControl,
        }
        if (!this.$store.getters.selectedSlide.audioShowControl) {
          this.$store.getters.selectedSlide.audioAutoPlay = true
          payload.audioAutoPlay = true
        }
        await this.updateSlide(payload)
      }
      if (typeUpdate === 3) {
        await this.updateSlide({
          audioAutoPlay: this.$store.getters.selectedSlide.audioAutoPlay,
        })
      }
      if (typeUpdate === 4) {
        await this.updateSlide({
          audioRepeat: this.$store.getters.selectedSlide.audioRepeat,
        })
      }
      if (typeUpdate === 5) {
        await this.updateSlide({
          audioPlayOnAudience: this.$store.getters.selectedSlide.audioPlayOnAudience,
        })
      }
      if (typeUpdate === 6) {
        payload = {
          audioAudienceShowControl: this.$store.getters.selectedSlide.audioAudienceShowControl,
        }
        if (!this.$store.getters.selectedSlide.audioAudienceShowControl) {
          this.$store.getters.selectedSlide.audioAudienceAutoPlay = true
          payload.audioAudienceAutoPlay = true
        }
        await this.updateSlide(payload)
      }
      if (typeUpdate === 7) {
        await this.updateSlide({
          audioAudienceAutoPlay: this.$store.getters.selectedSlide.audioAudienceAutoPlay,
        })
      }
      if (typeUpdate === 8) {
        await this.updateSlide({
          audioAudienceRepeat: this.$store.getters.selectedSlide.audioAudienceRepeat,
        })
      }
    },

    async updateSlide(payload) {
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage

      await this.updateMultipleSlides(payload)

      const changedAttrs = []
      Constant.commonSlideAttributes.forEach((attr) => {
        if (payload[attr] !== undefined) {
          changedAttrs.push(attr)
        }
      })

      Util.gaTrackEvent(
        PRESENTATION_EDITOR,
        this.$store.getters.selectedSlides.length > 1
          ? `Audio Tab > Change ${changedAttrs.join(', ')} for multiple slides`
          : `Audio Tab > Change ${changedAttrs.join(', ')} for single slide`,
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },

    async updateMultipleSlides(payload) {
      this.$store.dispatch('updateSlideActive', payload)
      if (!this.selectedSlideIds.length) {
        this.selectedSlideIds.push(this.$store.state.slideActive.id)
      }
      const slides = this.selectedSlideIds.map((id) => ({
        id,
        ...payload,
      }))

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides,
        })

        this.$store.getters.selectedSlides.forEach((slide) => {
          Constant.commonSlideAttributes.forEach((attr) => {
            if (payload[attr] !== undefined) {
              slide[attr] = payload[attr]
            }
          })
        })
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (err) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw err
      }
    },

    playDemo(item) {
      item.isPlay = !item.isPlay
      if (item.isPlay) {
        this.bmgList.forEach((a) => {
          if (a.title !== item.title) {
            if (a.audio) {
              a.audio.pause()
            }
            a.isPlay = false
          }
        })
        if (!item.audio) {
          item.audio = new Audio(item.url)
        } else {
          item.audio.currentTime = 0
        }
        item.audio.play().catch(() => {})
      } else if (item.audio) {
        item.audio.pause()
      }
      this.bmgList.push()
    },

    stopAllbmg() {
      this.bmgList.forEach((bmg) => {
        if (bmg.audio) {
          bmg.audio.pause()
          bmg.isPlay = false
        }
      })
      this.bmgList.push()
    },

    async selecAudio(item, event) {
      event.preventDefault()
      const payload = {}
      this.updateSlideActiveAction({
        audioName: item.title,
        audioLink: {
          name: item.title,
          url: item.url,
        },
      })
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage
      payload.audioLink = item.url
      payload.audioName = item.title
      this.showSelectBgmMenuSection = false
      await this.updateSlides(payload)
      this.showBmgList = false
      this.stopAllbmg()
      Util.ga4Track('Pick a sound track from the list', {
        eventAction: 'Audio Tab > Background music > Pick an audio track',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        audioTrack: item.title,
      })
    },
    async updateSlides(payload) {
      const instantPayload = {}
      Constant.commonSlideAttributes.forEach((attr) => {
        if (payload[attr] !== undefined) {
          instantPayload[attr] = payload[attr]
          // FIXME: Get & Set data should be the same format so we don't have to do this
          if (attr === 'audioLink') {
            instantPayload[attr] = {
              url: instantPayload[attr],
              name: payload.audioName,
            }
          }
        }
      })

      const appliedSlides = this.$store.getters.selectedSlides
      this.$store.dispatch('updateSlideActive', instantPayload)
      const slides = appliedSlides.map((slide) => ({
        id: slide.id,
        ...payload,
      }))

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        await SlideApi.updateSlides({
          presentationId: this.$store.state.presentation.id,
          slides,
        })

        appliedSlides.forEach((slide) => {
          Constant.commonSlideAttributes.forEach((attr) => {
            if (instantPayload[attr] !== undefined) {
              slide[attr] = instantPayload[attr]
            }
          })
        })

        this.$store.dispatch('setSyncPresentation', 2)
      } catch (err) {
        this.$store.dispatch('setSyncPresentation', 3)
        throw err
      }
    },
    closeBgmTrack() {
      this.showBmgList = false
    },
    triggerTrackingClickAudiobtn() {
      Util.ga4Track('Click to open the Audio tab', {
        eventAction: 'Open Audio Tab',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
    },
    openBackgroundListMenu() {
      this.showBmgList = true
      Util.ga4Track('Open drop down menu', {
        eventAction: 'Audio Tab > Background music > Activate dropdown menu',
        eventCategory: 'Presentation Editor',
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.custom-control {
  display: block;

  .custom-control-label {
    cursor: pointer;
    font-style: initial;
  }
}
.sub-group {
  padding-left: 23px;
}
.audio-track {
  margin-bottom: 16px;
}
.form-check-inline {
  display: block;
  margin-bottom: 8px;
}

.slide-image-config {
  background-color: #f2f2f2;
  .image-box {
    margin-top: 7px;
    font-weight: bold;
    img {
      max-width: 150px;
      max-height: 90px;
    }
  }

  a {
    margin-top: 16px;
  }
}
.item-video-change {
  margin-right:10px;
  &.change-audio-track {
    margin-right: 32px;
  }
}
.audio-tag {
  width: 100%;
  margin-top: 11px;

  audio {
    border: 2px solid #ccc;
    border-radius: 30px;
    width: 100%;
    height: 32px;
    max-width: 380px;
  }
}

.is-null {
  font-style: italic;
}

.input-select-track {
  border: 1px solid #D3D7E1;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  background: #ffffff;
  &:hover {
    background-color: rgba(249, 251, 255, 1);
    border-color: #4f9af2;
  }
  &:focus {
    border-color: #4f9af2;
  }
  .flex {
    margin: 0 8px;
  }
}

.select-track-or {
  margin: 0 8px;
}

.audience-list-track {
  background-color: #fff;
  border: 1px solid #D3D7E1;
  box-shadow: 3px 3px 5px rgba(211, 215, 225, 0.42);
  border-radius: 4px;
  padding: 4px;
  max-height: 375px;
  overflow-y: auto;
  position: absolute;
  top: 44px;
  width: 100%;
  z-index: 10;

  ul {
    padding-left: 0;
    margin-bottom: 0;
    li {
      padding: 8px;
      cursor: pointer;
      .button-play-track {
        width: 40px;
        height: 40px;
        text-align: center;
        background-color: #EFF1F7;
        border-radius: 40px;
        line-height: 40px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .icon-selected-track {
        @apply flex justify-center items-center;
        width: 20px;
        margin-left: auto;
      }
      &:hover {
        background-color: #F0F4FA;
        .button-play-track {
          background-color: #fff;
        }
      }
    }
  }
}
</style>
